import { Modal, Row, Col } from "antd";
import { Flex, Box, Text } from "@chakra-ui/react";
import DateRangePicker from "components/Input/DateRangePicker";
import { ListarFiltroEmailQuery } from "core/features/relatorios/typings";
import SelectDestino from "components/SelectDestinos/SelectDestino";
import { useState, useEffect } from "react";
import FiltroTagEmail from "./../FiltroTagEmail/FiltroTagEmail";
import { CloseModalButton } from "components/Button/CloseModalButton";
import FooterModal from "components/Button/FooterModal";
import Toolbar from "components/Toolbar";
import { useCurrentTenant } from "features/auth/tenant.store";
import { TipoEntidadeEnum } from "core/resources/enums/conta";
import { AssuntoMensagem } from "features/mensagens/typings";
import SelectBase from "components/Features/Financeiro/FormConta/components/SelectBase";
import useAssuntosMensagens from "features/mensagens/hooks/useAssuntosMensagens";
import { useForm } from "react-hook-form";
import Field from "components/Input/Field";
import TagAssunto from "./Components/TagAssunto";
import { defaultValuesFiltroEmail } from "./../../hooks/useFiltroEmail";
import { TipoDestinoEnum } from "features/documentos/enums";

interface ModalFiltroProps {
  open: boolean;
  onClose: () => any;
  onCancel: () => any;

  onChangeFiltro: (v: Partial<ListarFiltroEmailQuery>) => void;

  form?: any;

  filtro: any;
  onReset: any;
}

export default function ModalFiltro({
  open,
  onCancel,
  onChangeFiltro,
  onClose,
  filtro,
  onReset,
}: ModalFiltroProps) {
  const { control, setValue, watch, reset } = useForm<ListarFiltroEmailQuery>({
    defaultValues: filtro,
  });
  const [searchAssuntoText, setSearchAssuntoText] = useState("");
  const { data: assuntosMensagem } = useAssuntosMensagens();

  useEffect(() => {
    if (open) {
      reset({ ...filtro });
    }
  }, [filtro, open, reset]);

  const { tenant } = useCurrentTenant();

  const form = watch();

  const numeroFiltroSelecionados =
    (form.assuntos?.length || 0) +
    (form.status ? 1 : 0) +
    (form.tipoDestinoId === TipoDestinoEnum.TodasUnidades || form.destinoId
      ? 1
      : 0) +
    (form.email ? 1 : 0) +
    (form.dataInicio || form.dataFim ? 1 : 0);

  return (
    <Modal
      visible={open}
      onCancel={onClose}
      destroyOnClose
      className="antd-custom-header"
      closable={false}
      width="600px"
      title={
        <Toolbar title="Filtros avançados" onClose={onClose} border="0px" />
      }
      footer={
        <Flex
          justifyContent="end"
          align="center"
          gap="8px"
          alignContent="center"
          alignItems="center"
        >
          <CloseModalButton
            closeModalLabel="Fechar"
            close={onCancel}
            mt="32px"
          />
          <FooterModal
            isDisabled={false}
            onSubmit={() => {
              onChangeFiltro(form);
              onClose();
            }}
            onClose={() => {
              onReset();
              reset(defaultValuesFiltroEmail);
              onClose();
            }}
            showRegisterAnother={false}
            primaryButtonText="Filtrar"
            filtroValue={numeroFiltroSelecionados}
            buttonCancelarText="Limpar filtros"
            isLoadingSave={false}
          />
        </Flex>
      }
    >
      <Box as={Row} gutter={32} mb={4}>
        <Col sm={24}>
          <Field
            control={control}
            name="assuntos"
            label="Assuntos"
            sizeLabel="14px"
            render={({ field }) => (
              <>
                <SelectBase
                  showSearch
                  onChange={(v) => {
                    if (!field.value.includes(v)) {
                      field.onChange([...field.value, v]);
                    }
                  }}
                  onSearch={(v) => {
                    setSearchAssuntoText(v);
                  }}
                  searchValue={searchAssuntoText}
                  value={[]}
                  onKeyDown={(ev) => {
                    if (
                      ev.key === "Enter" &&
                      !field.value.includes(searchAssuntoText) &&
                      searchAssuntoText.length > 0
                    ) {
                      field.onChange([...field.value, searchAssuntoText]);
                    }
                  }}
                  autoClearSearchValue
                  notFoundContent={
                    <Flex
                      color={"black"}
                      onClick={() => {
                        if (
                          !field.value.includes(searchAssuntoText) &&
                          searchAssuntoText.length > 0
                        ) {
                          field.onChange([...field.value, searchAssuntoText]);
                          setSearchAssuntoText("");
                          (document.activeElement as any)?.blur?.();
                        }
                      }}
                    >
                      {field.value.includes(searchAssuntoText)
                        ? `${searchAssuntoText} já está na lista`
                        : `Clique aqui ou pressione enter para adicionar ${searchAssuntoText}`}
                    </Flex>
                  }
                  options={assuntosMensagem
                    ?.filter(
                      (v) =>
                        v.id !== AssuntoMensagem.Outros &&
                        !field.value.includes(v.nome)
                    )
                    .map((v) => ({
                      label: v.nome,
                      value: v.nome,
                    }))}
                />

                <Text fontSize={11} fontWeight="medium" mt={1}>
                  Digite e pressione enter para adicionar um assunto
                </Text>

                <Flex gap={2} wrap="wrap" mt={2}>
                  {form.assuntos?.map((assunto) => (
                    <TagAssunto
                      assunto={assunto}
                      onRemove={(assunto) => {
                        field.onChange(
                          field.value.filter((item: string) => item !== assunto)
                        );
                      }}
                    />
                  ))}
                </Flex>
              </>
            )}
          />
        </Col>
      </Box>

      <Box as={Row} gutter={32} mb={6}>
        <Col sm={24}>
          <Field
            control={control}
            name="email"
            label="Email"
            sizeLabel="14px"
            inputProps={{
              placeholder: "Ex: email1,email2,email3...",
            }}
          />
        </Col>
      </Box>

      <Box as={Row} gutter={32} mb={6}>
        <Box as={Col} xs={12}>
          <Text mb="5px">Período </Text>
          <DateRangePicker
            allowEmptyDates={{
              dataInicio: true,
              dataFim: false,
            }}
            onChange={(dataInicio, dataFim) => {
              setValue("dataInicio", dataInicio!);
              setValue("dataFim", dataFim!);
            }}
            value={{
              dataFim: form.dataFim,
              dataInicio: form.dataInicio,
            }}
          />
        </Box>
      </Box>

      <Box as={Row} gutter={32} mb={6}>
        <Col sm={24}>
          <Text mb="5px">Destino</Text>
        </Col>

        <Col sm={24}>
          <SelectDestino
            mr="0"
            control={control}
            form={form}
            label=""
            tenantId={tenant.id}
            setValue={setValue}
            tiposPessoa={[TipoEntidadeEnum.Condomino]}
          />
        </Col>
      </Box>
      <Box as={Row} gutter={32} mb={2}>
        <Col sm={24}>
          <Text mb="5px">Status de e-mail</Text>
        </Col>

        <Col sm={24}>
          <FiltroTagEmail
            selectedTipoEmail={form.status}
            setSelectedTipoEmail={(selected) => {
              setValue("status", selected);
            }}
          />
        </Col>
      </Box>
    </Modal>
  );
}
